import { Component, computed, inject, Input, input } from '@angular/core';
import { ProgressService } from '../lib/progress.service';
import { DayTypeType } from '@shared';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-progress-info',
  imports: [],
  templateUrl: './progress-info.component.html',
})
export class ProgressInfoComponent {
  public progressService = inject(ProgressService);
  public divider = input.required<boolean>();
  public displayDate = computed<string|null>(() => {
    if(!this.progressService.selectedDate()) {
      return ''
    }
    const date = new Date(this.progressService.selectedDate()!);
    const datePipe = new DatePipe('de-de');
    const correctedDate = date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    return datePipe.transform(correctedDate, 'EEEE, dd. MMM')
  })
  public breadcrumbs = computed<string>(() =>
    [
      this.progressService.selectedFestival()?.title_public,
      this.displayDate(),
      this.translateDayslot(this.progressService.selectedDayslot()),
      `${this.progressService.selectedLodge()?.title_public || ''} ${this.progressService.selectedPackage() ? '(' + this.progressService.selectedPackage()?.name_public + ')' : ''}`.trim(),
      this.progressService.selectedPersons() ? `${this.progressService.selectedPersons()} Person${(this.progressService.selectedPersons() === 1 ? '' : 'en')}` : ''
    ]
      .filter((val) => !!val)
      .join('&nbsp;|&nbsp;'),
  );

  public translateDayslot(slot: DayTypeType | null) {
    if (!slot) {
      return null;
    }
    switch (slot) {
      case 'evening':
        return 'Abend';
      case 'morning':
        return '(Nach-)mittag';
      default:
        return 'Unbekannt';
    }
  }
}
